export default {
  brandColor1: '#FF8700',
  complimentaryColor1: '#fff',
  brandColor2: '#FFD934',
  complimentaryColor2: '#fff',
};
